import React, { Fragment } from 'react';
import Typo from 'components/shared/Typo';
import RebootConfirmDialog from './RebootConfirmDialog';

function RebootGA2DeviceDialog(props) {
  return (
    <RebootConfirmDialog
      title={
        <Typo as="h3" variant="heading5">
          Reboot the Pivot system?
        </Typo>
      }
      description={
        <Fragment>
          <Typo paragraph variant="body1" color="error">
            Please note:
          </Typo>
          <Typo paragraph variant="body2" color="error">
            Rebooting the system will affect service on all Pivot sectors for up to 5 minutes.
          </Typo>
        </Fragment>
      }
      {...props}
    />
  );
}

export default RebootGA2DeviceDialog;
